import { useState } from "react";
import Select, { createFilter } from "react-select";

// styles and images
import Close from "../../assets/close.svg";
import "./Project.css";
import { projectStore, userStore } from "../../store/Store";
import { useGetLoadOptions } from "../../hooks/useGetLoadOptions";
import FormButton from "../../formComponents/FormButton";
import InlineInput from "../../formComponents/InlineInput";

export default function LockLoad({ setLoadLockTrigger, isAsset, endpoint }) {
  // global
  const currentUser = userStore((data) => data.currentUser);
  const JwtToken = userStore((data) => data.JwtToken);
  const projectLoads = projectStore((data) => data.projectLoads);
  const projectAssetLoads = projectStore((data) => data.projectAssetLoads);
  const setProjectLoads = projectStore((data) => data.setProjectLoads);
  const setProjectAssetLoads = projectStore(
    (data) => data.setProjectAssetLoads
  );

  const [formError, setFormError] = useState(null);
  const [lockedLoads, setLockedLoads] = useState(null);
  const [reason, setReason] = useState("");
  const [loadOptions, setLoadOptions] = useState(null);
  const [assetLoadOptions, setAssetLoadOptions] = useState(null);
  const [pending, setPending] = useState(false);

  useGetLoadOptions(setLoadOptions, "load_no", "id");
  useGetLoadOptions(setAssetLoadOptions, "load_no", "id", true);

  const handleLoads = (p) => {
    setLockedLoads(p);
  };

  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", "Bearer " + JwtToken);
  const filterConfig = { matchFrom: "start" };
  const customFilter = createFilter(filterConfig);
  const controller = new AbortController();
  const requestOptions = {
    method: "PATCH",
    headers,
    signal: controller.signal,
  };

  const handleLock = () => {
    setPending(true);
    if (reason === "") {
      setFormError("Please add a reason for locking the load(s).");
      setPending(false);
      return;
    } else if (!lockedLoads) {
      setFormError("Please select at least one load");
      setPending(false);
      return;
    }

    lockedLoads.forEach((l) => {
      var load;

      if (!isAsset) {
        load = projectLoads.filter((pL) => pL.id === l.value);
      } else {
        load = projectAssetLoads.filter((pL) => pL.id === l.value);
      }

      load[0].locked_reason = reason;
      load[0].updated_by_id = currentUser.id;
      requestOptions.body = JSON.stringify(load[0]);
      fetch(
        `${process.env.REACT_APP_BACKEND}/pc/${endpoint}/${load[0].id}`,
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.error === true) {
            console.log(data);
            setFormError(data.message);
            setPending(false);
            return;
          } else {
            if (!isAsset) {
              setProjectLoads(data);
            } else {
              setProjectAssetLoads(data);
            }
            setLoadLockTrigger(false);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setPending(false));
      return () => controller.abort();
    });
  };

  const handleUnlock = () => {
    setPending(true);

    if (!lockedLoads) {
      setFormError("Please select at least one load");
      setPending(false);
      return;
    }

    lockedLoads.forEach((l) => {
      var load;

      if (!isAsset) {
        load = projectLoads.filter((pL) => pL.id === l.value);
      } else {
        load = projectAssetLoads.filter((pL) => pL.id === l.value);
      }

      load[0].locked_reason = "";
      load[0].updated_by_id = currentUser.id;
      requestOptions.body = JSON.stringify(load[0]);
      fetch(
        `${process.env.REACT_APP_BACKEND}/pc/${endpoint}/${load[0].id}`,
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.error) {
            setFormError(data.message);
            setPending(false);
            return;
          } else {
            if (!isAsset) {
              setProjectLoads(data);
            } else {
              setProjectAssetLoads(data);
            }
            setLoadLockTrigger(false);
          }
        })
        .catch(_ => {
          setFormError("Something went wrong")
          return
        })
        .finally(() => setPending(false))
        return () => controller.abort()
    });
  };

  const handleClose = () => {
    setLoadLockTrigger(false);
  };

  return (
    <div className="popup">
      <div className="popup-inner">
        {formError && <div className="error">{formError}</div>}
        <div className="d-flex justify-content-between project-header">
          <h3>Lock/Unlock Load</h3>
          {!pending && (
            <div className="close">
              <img
                onClick={handleClose}
                src={Close}
                alt="close"
                className="close"
              />
            </div>
          )}
        </div>
        <div className="mb-3 row">
          <label className="col-form-label bold-label col-sm-3">
            Load Numbers
          </label>
          <div className="col-sm-7">
            <Select
              key={"load-select"}
              name="load-select"
              options={!isAsset ? loadOptions : assetLoadOptions}
              onChange={handleLoads}
              maxMenuHeight={300}
              isMulti
              filterOption={customFilter}
              required
            />
          </div>
        </div>
        <InlineInput
          name={"reason"}
          title={"Reason"}
          placeholder={"Reason"}
          type={"text"}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <FormButton pending={pending} name={"Lock"} onClick={handleLock} />
        <FormButton pending={pending} name={"Unlock"} onClick={handleUnlock} />
      </div>
    </div>
  );
}
